

const EcrdOverview = () => {
    return (
        <>

            <img class="full-width img-responsive mb-5" src="https://www.hbku.edu.qa/sites/default/files/ECRD%20Banner_0.jpg" alt="Early Career Researcher Development (ECRD) Cohort Program" width="1299" height="339" />
            <div class="row align-items-center mb-3">
                <div class="col-lg-6 col-xl-8">
                    <div class="me-md-2">
                        <h2 class="text-hbku-primary p-b-2">Early Career Researcher Development (ECRD) Cohort Program</h2>
                        <p class="p-b-2">The Early Career Researcher Development (ECRD) cohort is a wide program of Hamad Bin Khalifa University’s Office of the Vice President for Research. With a fixed duration of 4–6 months development journey for early-career researchers, including research fellows, postdoctoral researchers, scientists, and research staff seeking structured growth, mentorship, and foundational research excellence. </p>
                        <p class="p-b-2">Participants join a curated cohort that combines workshops, high-quality online training, and a formalized mentorship framework to accelerate research capability and professional advancement.
                        </p>

                    </div>
                </div>
                       <div class="col-lg-6 col-xl-4">
                    <div class="important-dates-card mb-4">
                        <h2 class="card-title">
                            ECRD Second Cohort - Important Dates
                        </h2>

                        <ul class="important-dates-list">
                            <li>
                                <span class="label">Applications open</span>
                                <strong class="date">1 September, 2026</strong>
                            </li>

                            <li>
                                <span class="label">Application Deadline</span>
                                <strong class="date">26 September, 2026</strong>
                            </li>

                            <li>
                                <span class="label">Cohort starts</span>
                                <strong class="date">November 2026</strong>
                            </li>

                            <li>
                                <span class="label">Cohort concludes</span>
                                <strong class="date">April 2027</strong>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>

            <div className="row mb-3">
                <div className="col-12">
                    <div className="t-block">
                        <div className="t-block__content d-block w-100">
                            <div className="row">
                                <div className="col-md-6 mb-4 mb-lg-0">
                                    <div className="t-block_list slow-up-down bg-grey-10 radius-6 w-100 h-100 m-0">

                                        <div class="t-block__list__info">
                                            <div class="t-block__list--title">
                                                <h4 class="fs-21 text-darkbluedarkblue item--title">Key goals</h4>
                                            </div>
                                            <div class="t-block__list--content">
                                                <div className="l-article">
                                                    <ul>
                                                        <li>Build Hamad Bin Khalifa University research capacity</li>
                                                        <li>Equip Early Career Researchers with core skills</li>
                                                        <li>Provide measurable mentorship</li>
                                                        <li>Support retention and progression</li>

                                                    </ul>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div class="t-block_list slow-up-down bg-grey-10 radius-6 w-100 h-100 m-0">

                                        <div class="t-block__list__info">
                                            <div class="t-block__list--title">
                                                <h4 class="fs-21 text-darkbluedarkblue item--title">Who is this for?</h4>
                                            </div>
                                                     <div class="t-block__list--content">
                                                <p>The ECRD Program is open to members of all HBKU colleges and research institutes. Eligible participants are:</p>
                                                <div className="l-article mt-3">

                                                    <ul>
                                                        {/* <li>Research Fellows</li>
                                                        <li>Postdoctoral Researchers</li>
                                                        <li>Scientists and Research Staff</li>
                                                        <li>Potentially selected PhD students</li> */}
                                                        <li>Postdoctoral fellows and research fellows</li>
                                                        <li>Early career scientists</li>
                                                        <li>Early career faculty members</li>
                                                    </ul>
                                                    {/* <em className="mt-2 d-block">This program is exclusive to HBKU affiliated ECRs</em> */}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
        </>


    )
}
export default EcrdOverview;